import{jsx as e,jsxs as t}from"react/jsx-runtime";import{styled as o}from"styled-components";import{linkName as n}from"../../../../domain/domain/UI/Link.name.mjs";import{jobStateToDisplay as a,JobState as r}from"../../../../domain/enums/JobState/JobState.enum.mjs";import{useLocalizedContents as i}from"../../../../messages/context/LocalizedContentsContext.mjs";import{useItemNames as l}from"../../../../domain/hooks/useItemName.mjs";import{Label as s}from"../../../../ui/components/base/Label/Label.mjs";import{dateToStr as d}from"../../../../utils/DateUtils.mjs";const c=o.td`
  border-bottom: 1px dotted #ccc;
  padding: 0px;
  margin: 0;
  padding-left: 8px;
`,m=o.div`
  display: inline;
  vertical-align: baseline;
`,p=o.div`
  margin: 5px 2px;
  float: left;

  &.running {
    background: url('images/loading.png') no-repeat scroll left center transparent;
    padding-left: 24px;
  }
`,g=o.div`
  color: #0088cc;
  padding-right: 5px;
  margin: 5px 2px;
  clear: both;

  a {
    background: url('images/download_16x16.png') no-repeat scroll right center transparent;
    padding-right: 18px;
    cursor: pointer;
  }
  a:hover {
    text-decoration: underline;
  }
`;function u({job:o,setIsDialogOpen:u,setDialogContents:b}){const{locale:h,dateTimeFormat:x}=i(),f=l(n),j=e=>{b({job:o,type:e}),u(!0)},k=o.jobState===r.executing;return e("tr",{children:e(c,{children:t("div",{className:"job",children:[e(s,{type:"block",children:o.jobFunctionName}),t("div",{children:["(発行時間:",e(m,{className:"label textDate",children:d(o.dateOfIssue,x)}),")"]}),e(p,{className:(k?"running ":"")+"status",children:a(o.jobState,h)}),e(p,{className:"stepStatus",children:k?o.progress:""}),o.hasOutputFiles&&o.jobState===r.completed&&e(g,{className:"downloadLink",children:e("a",{onClick:()=>j("outputFile"),children:f("outputFile")})}),o.jobState===r.checkError&&e(g,{className:"downloadLink",children:e("a",{onClick:()=>j("errorLog"),children:f("log")})})]})})})}export{u as JobItem};
